"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialCharacters = {
    "i": "ı",
    "j": "ȷ",
    "oe": "œ",
    "OE": "Œ",
    "ae": "æ",
    "AE": "Æ",
    "aa": "å",
    "AA": "Å",
    "o": "ø",
    "O": "Ø",
    "ss": "ß",
    "l": "ł",
    "L": "Ł"
};
function isSpecialCharacter(x) {
    return exports.specialCharacters.hasOwnProperty(x);
}
exports.isSpecialCharacter = isSpecialCharacter;
exports.specialCharacter = function (name) { return isSpecialCharacter(name) ? exports.specialCharacters[name] : undefined; };
//# sourceMappingURL=specialchars.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/unicode/commands/0args/specialchars.js
// module id = 105
// module chunks = 0 1 2 3